import request from '@/utils/request'

// 修改头像
export function updateWorkerAvatar(imgUrl) {
  const formData = new FormData()
  // 按后端要求使用 formData 格式，并带上 ajax_type=form
  formData.append('imgUrl', imgUrl)
  formData.append('ajax_type', 'form')
  return request({
    url: '/workers/handUpdate',
    method: 'post',
    data: formData
  })
}

// 修改昵称
export function updateWorkerName(name) {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('ajax_type', 'form')
  return request({
    url: '/workers/nameUpdate',
    method: 'post',
    data: formData
  })
}





// WEBPACK FOOTER //
// ./src/api/workers.js